export default __webpack_public_path__ + "static/media/arrow-right.2594db21.svg";